import { render, staticRenderFns } from "./app-warehouse.vue?vue&type=template&id=6a045f26&scoped=true&"
import script from "./app-warehouse.vue?vue&type=script&lang=js&"
export * from "./app-warehouse.vue?vue&type=script&lang=js&"
import style0 from "./app-warehouse.vue?vue&type=style&index=0&id=6a045f26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a045f26",
  null
  
)

export default component.exports